import { api } from "../../lib";

export interface GroupPermission {
  id: string;
  groupId: string;
  permissionId: string;
  createdAt: string;
  group?: { name: string } | null;
  permission?: { name: string; description: string } | null;
}

export interface CreateGroupPermissionData {
  groupId: string;
  permissionId: string;
}

export const groupPermissionsService = {
  getAll: async () => {
    return api.get<GroupPermission[]>("/admin/group-permissions");
  },

  getById: async (id: string) => {
    return api.get<GroupPermission>(`/admin/group-permissions/${id}`);
  },

  getByGroupId: async (groupId: string) => {
    return api.get<GroupPermission[]>(`/admin/groups/${groupId}/permissions`);
  },

  create: async (data: CreateGroupPermissionData) => {
    return api.post<GroupPermission>("/admin/group-permissions", data);
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/group-permissions/${id}`);
  },
};
